export const root = "r1210tvl";
export const imageContainer = "io1zndf";
export const image = "i1wiymny";
export const button = "b1ph33lk";
export const buttonSection = "b1egqubi";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");